export default __webpack_public_path__ + "23efa3f56272eca1c731486bb8cd5032.png";